module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/economic-group/component/economic-group/economic-group.component.scss
// module id = ./src/app/economic-group/component/economic-group/economic-group.component.scss
// module chunks = main